import { PhoneInfo, PreferredGender } from "interface/user"
import parsePhoneNumberFromString from "libphonenumber-js"
import { DEFAULT_PLACEHOLDER } from "./constants"
import { sortBy } from "./index"

export function prettyprintPhoneNumber(
	phoneNumber?: PhoneInfo,
	hasCommunications?: boolean,
) {
	if (!phoneNumber?.value) {
		return DEFAULT_PLACEHOLDER
	}
	const messaging = !phoneNumber.supportsTextMessages
		? " · No text messages support"
		: ""
	const comms =
		hasCommunications !== undefined
			? ` · ${hasCommunications ? "Active" : "Never contacted"}`
			: ""
	return `${parsePhoneNumberFromString(phoneNumber.value)?.formatInternational()}${messaging}${comms}`
}

export const getPronouns = (gender?: PreferredGender) => {
	switch (gender) {
		case "Female":
			return { self: "herself", possessive: "her", object: "her" }
		case "Male":
			return { self: "himself", possessive: "his", object: "him" }
		default:
			return { self: "themself", possessive: "their", object: "them" }
	}
}

export const sortByFullName = sortBy("fullName")
